








































import {Component, PropSync} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {SelectWings, ToggleWings, FilterWings, FilterSelectedItemWings, InputWings} from 'wings-ui-components';
import {OriginatorFilter} from "@/store/originators/types";
import {notifyError} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {FilterSelectedItemWings, SelectWings, ToggleWings, FilterWings, InputWings}})
export default class OriginatorsFilter extends BaseFilter<OriginatorFilter> {
  @PropSync('show') is_show!: boolean;
  @Getter("transportsForOriginatorsList") transportsForOriginatorsList: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("exportOriginators") actionExportOriginators: any;
  @Action("actionLog") actionLog: any;

  log: boolean = false

  defaultFilter(): OriginatorFilter {
    return {
      name: undefined,
      transport: undefined,
      status: undefined,
      comment: undefined,
    }
  }

  created() {
    this.actionGetTransports();
    this.filtered();
  }

  export(): void {
    try {
      this.actionExportOriginators(this.filter)
    } catch(error) {
      notifyError(error)
    }
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Originator",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      await this.actionGetOriginators(this.filter);
      if (this.log) await this.actionLog(this.logObject)
      this.log = true
    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }
}
